import React from "react";
import Landing from "../components/Landing";

const Home = () => {
  return (
    <>
      <Landing />
    </>
  );
};

export default Home;
